import { Flex, Image, Img, Link, useBreakpointValue } from "@chakra-ui/react";
import { MdOutlineDoubleArrow } from "react-icons/md";
import Slider from "react-slick";

import { useStoriesContents } from "@/hooks/Contents";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { StoriesContentsArray } from "@/types";
import { useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type Promo = {
  src: string;
  alt: string;
  url: string;
};

function ArrowProductsPrev(props) {
  const { className, style, onClick } = props;
  return (
    <MdOutlineDoubleArrow
      className={className}
      fill={"red"}
      style={{
        ...style,
        display: "block",
        margin: " 0",
        color: "#0766c7 !important",
        transform: "rotateY(180deg) translateY(-10px)"
      }}
      onClick={onClick}
      color="#0766c7"
    />
  );
}

function ArrowProductsNext(props) {
  const { className, style, onClick } = props;
  return (
    <MdOutlineDoubleArrow
      fill={"red"}
      className={className}
      style={{
        ...style,
        display: "block",
        margin: "0",
        color: "#0766c7 !important"
      }}
      onClick={onClick}
      color="#0766c7"
    />
  );
}

export function CarouselPromo() {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: true,
    md: false,
    lg: false,
    xl: true
  });
  const [ListPromo, setListPromo] = useState<StoriesContentsArray>(null);
  const [PromoData, PromoError, PromoLoading] = useStoriesContents();

  useIsomorphicLayoutEffect(() => {
    if (PromoData) {
      setListPromo(PromoData?.[0]?.contentsArray);
    }
  }, [PromoData]);

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 4,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    centerMode: false,
    nextArrow: <ArrowProductsNext id={"NextArrow"} />,
    prevArrow: <ArrowProductsPrev id={"PrevArrow"} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const renderSlides = () =>
    ListPromo.map((slide, index) => (
      <Link w={"calc(100%/3)"} href={slide.Url} transition=".5s" aria-hidden="true">
        <Image
          w={"full"}
          key={index}
          borderRadius={"5px"}
          loading="lazy"
          aria-hidden="true"
          src={slide.Image}
          alt={slide.Alt}
        />
      </Link>
    ));

  return (
    <>
      <Flex w={"1200px"} justifyContent={"center"}>
        <Flex w={"full"} gap={5} justifyContent={"space-between"}>
          {ListPromo ? renderSlides() : null}
        </Flex>
      </Flex>
    </>
  );
}
